import React, {useState, useEffect} from 'react'
import axios from 'axios';

const Rooms = () => {
   useEffect(()=>{
       
   })
   
    axios.


    return (
    <div>Rooms</div>
    )
}

export default Rooms